/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const MobilePhoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="20"
    viewBox="0 0 14 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="MobilePhoneIcon">
    <path
      d="M2.41671 2.66667V17.3333H11.5834V2.66667H2.41671ZM1.50004 0.833336H12.5C12.7432 0.833336 12.9763 0.929913 13.1482 1.10182C13.3201 1.27373 13.4167 1.50689 13.4167 1.75V18.25C13.4167 18.4931 13.3201 18.7263 13.1482 18.8982C12.9763 19.0701 12.7432 19.1667 12.5 19.1667H1.50004C1.25693 19.1667 1.02377 19.0701 0.85186 18.8982C0.679951 18.7263 0.583374 18.4931 0.583374 18.25V1.75C0.583374 1.50689 0.679951 1.27373 0.85186 1.10182C1.02377 0.929913 1.25693 0.833336 1.50004 0.833336ZM7.00004 14.5833C7.24316 14.5833 7.47631 14.6799 7.64822 14.8518C7.82013 15.0237 7.91671 15.2569 7.91671 15.5C7.91671 15.7431 7.82013 15.9763 7.64822 16.1482C7.47631 16.3201 7.24316 16.4167 7.00004 16.4167C6.75693 16.4167 6.52377 16.3201 6.35186 16.1482C6.17995 15.9763 6.08337 15.7431 6.08337 15.5C6.08337 15.2569 6.17995 15.0237 6.35186 14.8518C6.52377 14.6799 6.75693 14.5833 7.00004 14.5833Z"
      fill="var(--brand-bg-primary)"
    />
  </svg>
);

export default MobilePhoneIcon;
